import type { UseTweaksResult } from "./tweaks2";

/**
 * Resolve a `useTweaks` result to one enum variant: the variant whose
 * registered option boolean is true, else the code default. The default is the
 * mechanism's implicit "existing" option, so it is never registered — every
 * fall-through case (no selection, "existing" picked, provider absent,
 * production build) lands on it.
 */
export function resolveTweakedVariant<Variant extends string>({
  tweaks,
  options,
  fallback,
}: {
  tweaks: UseTweaksResult;
  options: readonly Variant[];
  fallback: Variant;
}): Variant {
  return options.find((option) => tweaks[option] === true) ?? fallback;
}
